import React, { useEffect } from "react";

const DiscourseComments = ({ identifier, url }) => {
  useEffect(() => {
    // Configuration Discourse
    window.DiscourseEmbed = {
      discourseUrl: "https://forum.clotere.fr/",
      discourseEmbedUrl: url || window.location.href,
      identifier: identifier,
    };

    // Ajout du script Discourse
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = window.DiscourseEmbed.discourseUrl + "javascripts/embed.js";

    document.body.appendChild(script);

    // Nettoyage si le composant est démonté
    return () => {
      const iframe = document.querySelector("iframe[src*='discourse']");
      if (iframe) iframe.remove();
    };
  }, [identifier, url]);

  return (
    <>
      <div id="discourse-comments"></div>
      {/* Tu peux aussi mettre ici une fallback ou loader si besoin */}
    </>
  );
};

export default DiscourseComments;